(function ($, window, undefined) {

	/*
	 * Depoimentos paginação tamanho
	 */
	(function () {
		'use strict';

		var itemWidth = $('.box-depoimentos .depoimentos-pag li:not(.ativo):eq(0)').outerWidth() + 1;
		var itemHeight = $('.box-depoimentos .depoimentos-pag li:not(.ativo):eq(0)').outerHeight() + 32;
		var qtdItems = $('.box-depoimentos .depoimentos-pag li').length;
		var ulWidth = itemWidth * qtdItems;

		$('.box-depoimentos .depoimentos-pag').css({
			'width': ulWidth,
			'height': itemHeight
		});

		$('.depoimentos-pag-scroll').mCustomScrollbar({
			axis: 'x',
			advanced: {
				autoExpandHorizontalScroll: true
			}
		});

	}());

	// Transição
	(function () {
		'use strict';

		var $boxDepoimentosLi = $('.box-depoimentos .depoimentos li'),
			$boxDepoimentosLiImg = $('.box-depoimentos .depoimentos li img'),
			$boxDepoimentosLiDepoimentoTexto = $('.box-depoimentos .depoimentos li .depoimento-texto'),
			$paginacaoLi = $('.box-depoimentos .depoimentos-pag li');

		$boxDepoimentosLi.eq(0).addClass('ativo');
		$boxDepoimentosLi.eq(0).find('img').addClass('transition');
		$boxDepoimentosLi.eq(0).find('.depoimento-texto').addClass('transition');

		$paginacaoLi.eq(0).addClass('ativo');

		$paginacaoLi.on('click', function () {
			var index = $(this).index();
			$boxDepoimentosLi.removeClass('ativo');
			$boxDepoimentosLiImg.removeClass('transition');
			$boxDepoimentosLiDepoimentoTexto.removeClass('transition');

			$paginacaoLi.removeClass('ativo');

			$boxDepoimentosLi.eq(index).addClass('ativo');

			setTimeout(function () {
				$boxDepoimentosLi.eq(index).find('img').addClass('transition');
				$boxDepoimentosLi.eq(index).find('.depoimento-texto').addClass('transition');
			});
			$paginacaoLi.eq(index).addClass('ativo');
		});
	}());

}(jQuery, window));